export default __webpack_public_path__ + "static/media/text-bold.3d3c240d.svg";